export default {
    API_ENDPOINT: 'https://stark-retreat-17766.herokuapp.com/api',
    //API_ENDPOINT: 'https://rocky-badlands-66274.herokuapp.com/api',
    TOKEN_KEY: 'pref-card-client-auth-token'
}